/**
 *  Identity root file
 * **/

import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

import regeneratorRuntime from "regenerator-runtime";
import { v4 as uuidv4 } from 'uuid';
import { Modal } from './dependents/common/Modal';
import { WidgetType } from './dependents/containers/widgetType';
import { trackBusinessEvt } from "./dependents/common/CustomEvents";
import { jwtDecode } from 'jwt-decode';
import './iiris-identity.css';
import * as IdentityUtils from './dependents/common/IdentityUtils';
import { loadWidgetByConfig,loadAndDecryptConfigData } from './loadWidgetByConfig';

const IrisIdentity = props => {
	const { identityConfig } = props;
	const [isLoggedInUser, setIsLoggedInUser] = useState(false);
	const [formType, setFormType] = useState('');
	const [user, setUser] = useState(null);
	const [isOpen, setIsOpen] = useState(false);
	const [forgetPasswordScreenConfig, setForgetPasswordScreenConfig] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [idToken, setIdToken] = useState('');
	const [position, setPosition] = useState('fixed');
	const apiBaseURL = identityConfig.apiBaseURL;

	identityConfig.toggleModal = (formType='') => {	
		if(formType ==='signin' || formType ==='signup' || formType ==='forgetpassword'){
			IdentityUtils.clearIRISCookies();
		}
		if (window.localStorage.getItem("trackedFields")) {
			//Tracker Sign Up Event for Sign Up
			const transactionID = window.localStorage.getItem("regTransactionId");
			const metadata = window.localStorage.getItem("trackedFields");
			const pageDetails = JSON.parse(metadata).abandoned_on;
			const eventData = {
				formId: 'registration',
				status: pageDetails,
				type: 'abandoned',
				tags: 'SignUp',
			}
			sendTrackerEvent(transactionID, metadata, eventData);
			window.localStorage.removeItem("trackedFields");
		}
		setIsOpen(!isOpen);
		if(localStorage.getItem('widget_screen') === 'profile_form'){
			window.location.reload()
		}
		if(window.location.pathname.includes('register') && !IdentityUtils.getIIRISCookie("IRIS_ID")){
			document.getElementById('irisRegisterBtn').click();
			setIsOpen(isOpen);
		}
	};

	identityConfig.redirectToProfilePage = () => {
		if (document.getElementById("iiris-modal-close-btn")) {
			sessionStorage.setItem("redirectedToProfile",true);
			document.getElementById("iiris-modal-close-btn").click();
		} else {
			identityConfig.toggleModal();
		}
	};

	const sendTrackerEvent = (transactionID, metadata, eventData) => {
		try {
			const evt = {
				entityId: 'NA',
				transactionId: transactionID,
				formId: eventData.formId,
				status: eventData.status,
				type: eventData.type,
				ts: new Date().toISOString()
			}
			const asset = {
				id: 'NA',
				name: window.location.host,
				type: 'form',
				size: 0,
				url: window.location.href,
				created: new Date().toISOString(),
				lastUpdated: new Date().toISOString(),
				tags: eventData.tags,
				metadata: metadata,
			}
			trackBusinessEvt(evt, asset);
		}
		catch (error) {
			console.log(error);
		}
	};

	const trackStructEvt = (act, prop) => {
		try {
			const evtObj = {};
			evtObj.cat = 'IRISIdentityEvent';
			evtObj.lbl = 'Page Visited';
			evtObj.act = act;
			evtObj.prop = prop;
			evtObj.val = 1.00;
			if (window.IIRISTracker && window.IIRISTracker.trackStructEvt) {
				window.IIRISTracker.trackStructEvt(evtObj);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const register = () => {
		setIsLoading(false);
		IdentityUtils.clearIRISCookies();
		localStorage.removeItem('CheckLocalUser');
		localStorage.setItem('widget_screen', 'signup');
		localStorage.removeItem('auth_flow');
		localStorage.setItem("iiris_ust", new Date());
		window.localStorage.removeItem("trackedFields");
		!window.location.href.includes("register") && sessionStorage.setItem("signup_referrer", window.location.href); //saving the current page location into session storage to redirect the user back to this page in case of one page registration
		setFormType('signup');
		setIsOpen(true);

		//Tracker Initial Event for Sign Up
		const transactionID = uuidv4();
		window.localStorage.setItem("regTransactionId", transactionID);
		const eventData = {
			formId: 'NA',
			status: 'init',
			type: 'register',
			tags: 'Initiated',
		}
		sendTrackerEvent(transactionID, '', eventData);
		trackStructEvt('register', 'Register');
	};

	const login = () => {
		setIsLoading(false);
		IdentityUtils.clearIRISCookies();
		localStorage.setItem('widget_screen', 'signin');
		localStorage.removeItem('CheckLocalUser');
		localStorage.removeItem('auth_flow');
		setFormType('signin');
		setIsOpen(true);
		localStorage.setItem("iiris_ust", new Date());
		trackStructEvt('login', 'Login');
	}

	const reload = async (id_token=idToken) => {
		const formType = identityConfig.registrationType !== "OnePage" ? "workemailcheck" : "workemailcheck_onepage";
		if (formType === "workemailcheck_onepage") {
			setPosition("fixed");
		}
		setUser(null);
		setFormType(formType);
		setIsLoading(true);
		IdentityUtils.getCognitoUser(id_token).then(user => {
			if (user != null && user.email !== "") {
				setIsLoading(false);
				setUser(user);
				setIsLoggedInUser(true);
			}
		}).catch((e) => {
			setIsLoading(false);
		});
	};

	const logoutApp = async ()=>{
		if (window.IIRISTracker) {
			window.IIRISTracker.clearTrackingUID()
		}
		setUser(null);
		setIsLoggedInUser(false);
		setIsOpen(false);
		sessionStorage.removeItem("redirectedToProfile");
		await IdentityUtils.logOutSession(apiBaseURL);
		window.location.reload()
	}

	const updateUser = async (token) => {
		try {
			if(!token) throw new Error("Anonymous User!")
			IdentityUtils.getCognitoUser(token).then((user) => {
				if (user != null && user.email !== "") {
					const checkForLocalUser = localStorage.getItem("CheckLocalUser") && localStorage.getItem("CheckLocalUser") === "NO";
					if (checkForLocalUser) {
						if (window.identitySuccessCallback) {
							window.identitySuccessCallback(user);
						}
					} else if (!identityConfig.show_registration) {
						setFormType("workemailcheck");
					}
					setIsLoggedInUser(!checkForLocalUser);
					setIsOpen(!checkForLocalUser);
					setUser(user);
				}
			}).catch(err => {
				console.log("Failed to retrieve cognito user Details: "+err);
			});
		} catch (error) {
			setUser(null);
			if (window.irisProfileMgrCallback) {
				const widgetReloadCallbackObj = { "success": true, "user": null, "token": null, "idToken": null };
				window.irisProfileMgrCallback(widgetReloadCallbackObj);
			}
			if (!identityConfig.show_registration) {
				setFormType("");
				setIsOpen(true);
			}
		}
		if (window.iirisIdentityLibLoaded) {
			window.iirisIdentityLibLoaded();
		}
	};

	const setResponseToCookies = (responseData) => {
		localStorage.setItem("is_social_login", true);
		try {
			document.cookie = `IRIS_AUTH=${responseData.access_token}; path=/; max-age=${responseData.expires_in}; samesite=strict; secure;domain=${window.location.hostname}`;
			document.cookie = `IRIS_HASH=${responseData.refresh_token}; path=/; max-age=${responseData.refresh_token_expiry || 7776000}; samesite=strict; secure;domain=${window.location.hostname}`;
			document.cookie = `IRIS_IDT=${responseData.id_token}; path=/; max-age=${responseData.refresh_token_expiry || 7776000}; samesite=strict; secure;domain=${window.location.hostname}`;
			setIdToken(responseData.id_token);
			reload(responseData.id_token);
		} catch (e) {
			console.log(e);
		}
	};

	const iirisLinkedinAuthHandler = code => {
		setFormType("");
		if (identityConfig.registrationType === "OnePage") {
			setPosition("fixed");
		}
		setIsLoading(true);
		const body = {
			client_id: identityConfig.clientId
		}
		fetch(apiBaseURL + '/v3/authorization/public/linkedInAuth', {
			method: 'POST',
			headers: {
				"Authorization": code,
				"Content-Type": "application/json"
			},
			body: JSON.stringify(body)
		}).then((response) => response.json())
			.then((responseData) => {
				setResponseToCookies(responseData.data);
			}).catch(err => {
				console.log(err);
			})
	};

	const iirisSocialAuthHandler = (code, url) => {
		var details = {
			'grant_type': 'authorization_code',
			'client_id': process.env.REACT_APP_PASSPORT_SOCIAL_LOGIN_APP_CLIENT_ID,
			'code': code,
			'code_verifier': localStorage.getItem("ouath_pkce_key"),
			'redirect_uri': url
		};

		var formBody = [];
		for (var property in details) {
			var encodedKey = encodeURIComponent(property);
			var encodedValue = encodeURIComponent(details[property]);
			formBody.push(encodedKey + "=" + encodedValue);
		}
		formBody = formBody.join("&");

		fetch('https://' + process.env.REACT_APP_COGNITO_DOMAIN + '/oauth2/token', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			},
			body: formBody
		}).then((response) => response.json())
			.then((responseData) => {
				setResponseToCookies(responseData);
			}).catch(err => {
				console.log(err);
			})
	};

	window.iirisLogoutHandler = async () => {
		//Clear Tracking UserID
		if (window.IIRISTracker) {
			window.IIRISTracker.clearTrackingUID();
		}
		setUser(null);
		setIsLoggedInUser(false);
		setIsOpen(false);
		localStorage.removeItem('CheckLocalUser');
		localStorage.removeItem('auth_flow');
		localStorage.removeItem('iiris_ust');
		await IdentityUtils.revokeIRISToken();
		IdentityUtils.clearIRISCookies();
		if (window.irisLogoutCallback) {
			const logoutObj = { "success": true };
			window.irisLogoutCallback(logoutObj);
		}
		document.cookie = 'IDENTITY_LOCALE=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=' + window.location.hostname;
	}

	window.handleMessageEvent = function(e) {
		window.removeEventListener("message", window.handleMessageEvent, false);
		try {
		   const { code, redirect_url } = e.data;
		   if (code) {
			  setUser(null);
			  if (redirect_url) {
				 iirisSocialAuthHandler(code, redirect_url);
			  } else {
				 iirisLinkedinAuthHandler(code);
			  }
		   } else {
			  window.addEventListener("message", window.handleMessageEvent, false);
		   }
		} catch (error) {
		   console.error("Error during message handling:", error);
		   window.addEventListener("message", window.handleMessageEvent, false);
		}
	 };	 

	useEffect(() => {
		const formType = localStorage.getItem('widget_screen');
		const idT = IdentityUtils.getIIRISCookie("IRIS_IDT");
		if (formType === "workemailcheck_onepage") {
			setFormType(formType)
		}
		updateUser(idToken || idT);
	}, []);

	return (
		<div>
			<div style={{ display: 'none' }}>
				{identityConfig.show_registration &&
					<>
						<input
							id='irisRegisterBtn'
							type='button'
							value='Register'
							onClick={register}
						/>
						<input id='irisLoginBtn' type='button' value='LogIn' onClick={login} />
					</>
				}
				<input
					id='irisLogoutBtn'
					type='button'
					value='LogOut'
					onClick={logoutApp}
				/>
				<input
					id='irisReloadBtn'
					type='button'
					value='reload'
					onClick={reload}
				/>
			</div>
			{isOpen && (
				identityConfig.is_modal ? (
					<Modal
						identityConfig={identityConfig}
						content={
							<WidgetType
								isLoading={isLoading}
								formType={formType}
								setFormType={setFormType}
								identityConfig={identityConfig}
								forgetPasswordScreenConfig={forgetPasswordScreenConfig}
								setForgetPasswordScreenConfig={setForgetPasswordScreenConfig}
								user={user}
								isLoggedInUser={isLoggedInUser}
								idToken={idToken}
								setPosition={setPosition}
							/>}
						position={position}
						isLoading={isLoading}
						handleClose={() => identityConfig.toggleModal(formType)}
					/>
				) : (
					<div className='iiris-container-body'>
						<div className='iiris-container'>
							<WidgetType
								isLoading={isLoading}
								formType={formType}
								setFormType={setFormType}
								identityConfig={identityConfig}
								forgetPasswordScreenConfig={forgetPasswordScreenConfig}
								setForgetPasswordScreenConfig={setForgetPasswordScreenConfig}
								user={user}
								isLoggedInUser={isLoggedInUser}
								idToken={idToken}
							/>
						</div>
					</div>
				)
			)}
		</div>
	)
};



const loadIdentityWidget = async () => {
	const identityWidget =  document.getElementById('iiris-identity');
  
	try {
	  // Wait for the configuration data to be fetched
	  await loadAndDecryptConfigData();
	  // Get props after the configuration data is loaded
	  let props = loadWidgetByConfig.getInstanceProps();
  
	  if (props && identityWidget) {
		ReactDOM.render(React.createElement(IrisIdentity, props), identityWidget);
	  }
	} catch (error) {
	  console.error("Error while loading config data or rendering:", error);
	}
  };
  loadIdentityWidget();





export { IrisIdentity }
